import { useQuery } from '@tanstack/react-query';
import { exchanges } from '@/api/endpoints';
import { deriveMode, modeDetail, modeLabel } from '@/lib/mode';
import { ConnectionStatus } from './ConnectionStatus';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

/**
 * The persistent mode banner (ARCHITECTURE.md section 14.5).
 *
 * Not dismissible, not collapsible, and rendered before the page content so it
 * is the first thing read. While accounts are still loading it shows nothing
 * rather than guessing, because a banner that says PAPER and then corrects
 * itself to LIVE is worse than a banner that waits.
 */
export function ModeBanner() {
  const { data, isPending } = useQuery({
    queryKey: ['exchange-accounts'],
    queryFn: exchanges.accounts,
    refetchInterval: 30_000,
  });

  const summary = deriveMode(data);
  const mode = isPending ? 'NONE' : summary.mode;

  return (
    <header className="mode-banner" data-mode={mode} role="banner">
      <span className="mode-label" data-testid="mode-label">
        {isPending ? 'CHECKING MODE' : modeLabel(summary.mode)}
      </span>
      <span className="mode-detail">{isPending ? '' : modeDetail(summary)}</span>
      <div className="mode-spacer" />
      <ConnectionStatus />
      <ThemeToggle />
      <UserMenu />
    </header>
  );
}
